import { Routes, Route, Navigate } from "react-router-dom";
import MainLayout from "./components/MainLayout";
import Selfie from "./pages/Selfie";
import NotFound from "./pages/NotFound";
import Instructions from "./pages/Instructions";
import FAQ from "./pages/FAQ";
import AwaitProposal from "./pages/AwaitProposal";
import ProposalWrapper from "./pages/ProposalWrapper";
import ShowProposal from "./pages/ShowProposal";
import UserStatus from "./pages/UserStatus";
import FGTSTutorial from "./pages/FGTSTutorial";
import ShareLinkPage from "./components/ShareLinkPage";
import OnBoarding from "./pages/OnBoarding";

function CommonRoutes() {
  return [
    <Route index element={<Instructions />} key="instructions" />,
    <Route path="onboard" element={<OnBoarding />} key="onboard" />,
    <Route path="introducao" element={<Instructions />} key="introducao" />,
    <Route path="loading" element={<AwaitProposal />} key="loading" />,
    <Route path="proposal/:id" element={<ProposalWrapper />} key="proposal-id" />,
    <Route path="proposal/link" element={<ShareLinkPage />} key="proposal-link" />,
    <Route path="show-proposal" element={<ShowProposal />} key="show-proposal" />,
    <Route path="tutorial" element={<FGTSTutorial />} key="tutorial" />,
    <Route path="selfie" element={<Selfie />} key="selfie" />,
    <Route path="FAQ" element={<FAQ />} key="FAQ" />,
    <Route path="status" element={<UserStatus />} key="status" />,
  ];
}

export default function GranaTech() {
  return (
    <Routes>
      <Route path="/:slug" element={<MainLayout />}>
        {CommonRoutes()}
        <Route path=":slugSeller">
          {CommonRoutes()}
          <Route path=":slugSelfService">
            {CommonRoutes()}
          </Route>
        </Route>
      </Route>
      <Route path="/404" element={<NotFound />} />
      <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
  );
}
